import script from "./RegisterLocationUser.vue?vue&type=script&setup=true&lang=js"
export * from "./RegisterLocationUser.vue?vue&type=script&setup=true&lang=js"

import "./RegisterLocationUser.vue?vue&type=style&index=0&id=40c0fd4a&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-40c0fd4a"]])

export default __exports__